import { BreakpointAspectRatioConfigs } from '@uikit/components/LegacyPicture/image-transformer/types';
import { BreakPoint } from '../../../../hooks/useBreakPoint/consts';
import { MagazineTeaserArticleVariant } from './interfaces';

export const breakPointAspectRatioConfigs: {
  [key in MagazineTeaserArticleVariant]: BreakpointAspectRatioConfigs;
} = {
  extraLarge: [
    {
      breakpoint: BreakPoint.XSS,
      aspectRatio: '4:3',
      width: 343,
    },
    {
      breakpoint: BreakPoint.XS,
      aspectRatio: '4:3',
      width: 512,
    },
    {
      breakpoint: BreakPoint.SM,
      aspectRatio: '4:3',
      width: 336,
    },
    {
      breakpoint: BreakPoint.MD,
      aspectRatio: '16:10',
      width: 620,
    },
    {
      breakpoint: BreakPoint.LG,
      aspectRatio: '16:10',
      width: 780,
    },
    {
      breakpoint: BreakPoint.XL,
      aspectRatio: '16:10',
      width: 854,
    },
  ],
  large: [
    {
      breakpoint: BreakPoint.XSS,
      aspectRatio: '4:3',
      width: 343,
    },
    {
      breakpoint: BreakPoint.XS,
      aspectRatio: '4:3',
      width: 240,
    },
    {
      breakpoint: BreakPoint.SM,
      aspectRatio: '4:3',
      width: 336,
    },
    {
      breakpoint: BreakPoint.MD,
      aspectRatio: '4:3',
      width: 288,
    },
    {
      breakpoint: BreakPoint.LG,
      aspectRatio: '4:3',
      width: 755,
    },
    {
      breakpoint: BreakPoint.XL,
      aspectRatio: '4:3',
      width: 830,
    },
  ],
  medium: [
    {
      breakpoint: BreakPoint.XSS,
      aspectRatio: '4:3',
      width: 343,
    },
    {
      breakpoint: BreakPoint.XS,
      aspectRatio: '4:3',
      width: 240,
    },
    {
      breakpoint: BreakPoint.SM,
      aspectRatio: '4:3',
      width: 336,
    },
    {
      breakpoint: BreakPoint.MD,
      aspectRatio: '9:16',
      width: 288,
    },
    {
      breakpoint: BreakPoint.LG,
      aspectRatio: '9:16',
      width: 347,
    },
    {
      breakpoint: BreakPoint.XL,
      aspectRatio: '9:16',
      width: 384,
    },
  ],
  small: [
    {
      breakpoint: BreakPoint.XSS,
      aspectRatio: '4:3',
      width: 172,
    },
    {
      breakpoint: BreakPoint.XS,
      aspectRatio: '4:3',
      width: 240,
    },
    {
      breakpoint: BreakPoint.SM,
      aspectRatio: '4:3',
      width: 336,
    },
    {
      breakpoint: BreakPoint.MD,
      aspectRatio: '4:3',
      width: 288,
    },
    {
      breakpoint: BreakPoint.LG,
      aspectRatio: '4:3',
      width: 347,
    },
    {
      breakpoint: BreakPoint.XL,
      aspectRatio: '4:3',
      width: 384,
    },
  ],
};
